export const eventPropGetter = (event) => ({
  style: {
    backgroundColor:
      event.status === "completed"
        ? "#4CAF50"
        : event.status === "assigned"
        ? "#FFC107"
        : event.status === "out_of_service"
        ? "#F44336"
        : "#007bff",
    color: "white",
  },
});

export const modalStyle = {
  content: {
    width: "95%",
    maxWidth: "1400px",
    margin: "auto",
    maxHeight: "90vh",
    overflow: "auto",
    padding: "20px",
  },
};

export const scheduleData = ( selectedSchedule, technicianSignature ) => {
  return {
    start_time: selectedSchedule?.service_started_at,
    end_time: selectedSchedule?.service_completed_at,
    client: {
      name: selectedSchedule?.client.name,
    },
    client_phone: selectedSchedule?.client.phone,
    elevator: {
      id: selectedSchedule?.elevator_id,
      identifier: selectedSchedule?.elevator.identifier,
      building: {
        name: selectedSchedule?.elevator.building.name,
      },
    },
    place: `${selectedSchedule?.client.name} ${selectedSchedule?.elevator.building.location.name} ${selectedSchedule?.elevator.building.name} ${selectedSchedule?.elevator.identifier}`,
    description: selectedSchedule?.schedule_checklists
      .filter((checklist) => {
        const question = selectedSchedule?.checklist_questions.find(
          (q) =>
            q.id === checklist.checklist_question_id &&
            q.question === "observaciones"
        );
        return (
          question?.service_type === selectedSchedule?.service_type &&
          checklist.notes
        );
      })
      .map((item) => item.notes),
    schedule_checklists: selectedSchedule?.schedule_checklists,
    questions: selectedSchedule?.checklist_questions.filter(
      (x) => x.service_type === selectedSchedule.service_type
    ),
    service_type: selectedSchedule?.service_type,
    status: selectedSchedule?.status,
    user: {
      name: selectedSchedule?.user.name,
      document: selectedSchedule?.user.document,
    },
    work_done: selectedSchedule?.schedule_checklists
      .filter((checklist) => {
        const question = selectedSchedule?.checklist_questions.find(
          (q) =>
            q.id === checklist.checklist_question_id &&
            q.question === "trabajos realizados"
        );
        return (
          question?.service_type === selectedSchedule?.service_type &&
          checklist.notes
        );
      })
      .map((item) => item.notes),
    signature_url: selectedSchedule?.signature_url,
    technicianSignature: technicianSignature,
    id: selectedSchedule?.id,
    document: selectedSchedule?.document,
    person_name: selectedSchedule?.person_name,
  };
};
